/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Missing_DataInputs */

const es_cap_err_missing_data = /** @type {(inputs: Cap_Err_Missing_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltan datos`)
};

const gl_cap_err_missing_data = /** @type {(inputs: Cap_Err_Missing_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltan datos`)
};

const en_cap_err_missing_data = /** @type {(inputs: Cap_Err_Missing_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing information`)
};

/**
* | output |
* | --- |
* | "Missing information" |
*
* @param {Cap_Err_Missing_DataInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_missing_data = /** @type {((inputs?: Cap_Err_Missing_DataInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Missing_DataInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_missing_data(inputs)
	if (locale === "en") return en_cap_err_missing_data(inputs)
	return es_cap_err_missing_data(inputs)
});